import React, { Component } from 'react';
import cx from 'classnames';
import styles from './forgot-password-page.module.scss';
import Nav from '../../common/component/Nav/Nav';
import MainContainer from '../../common/component/MainContainer';
import FormContainer from '../../common/component/FormContainer';
import Footer from '../../common/component/Footer';
import CmsAPI from '../../../common/apis/CmsAPI';
import { CustomInput } from '../../../engage/components/Input/Input';
import { CustomButton } from '../../../engage/components/Button/Button';
import MobileHeader from '../../../engage/components/MobileHeader';
import ProtectedPageSidebar from '../../../engage/components/Sidebar/ProtectedPageSidebar';
import { withTranslation } from 'react-i18next';
import { ToastNotification } from '../../../engage/components/Toast/Toast';
import queryString from 'query-string';
import AuthorizationService from '../../../engage/service/AuthorizationService';
import { isLoggedIn } from '../../../engage/utils/auth-util';
import { isEmailFormatValid } from '../../../engage/utils/stringHelper';

class ForgotPasswordPage extends Component {
  state = {
    email: '',
    isEmailError: false,
    loading: false,
    isMobileView: false,
    isEmailValid: false,
    isEmailTouched: false,
  };

  async componentDidMount() {
    const mediaMatch = window.matchMedia('(max-width: 900px)');
    this.setState({ isMobileView: mediaMatch.matches });
    this.props.location?.state?.email &&
      this.setState({ email: this.props.location.state.email, isEmailValid: isEmailFormatValid(this.props.location.state.email) });

    const isDesktopRedirect = this.props.location.search.includes('desktopEmail');

    const searchWithPlusSign = this.props.location.search.replaceAll('+', '%2B');
    const { desktopEmail } = queryString.parse(searchWithPlusSign);

    if (isDesktopRedirect) {
      const firstUserCheck = await isLoggedIn();

      if (firstUserCheck) {
        await AuthorizationService.logOut(desktopEmail);
      }

      this.setState({ email: desktopEmail });
      return;
    }

    const userCheck = await isLoggedIn();

    // Redirect to the dashboard if user already logged in
    if (userCheck) {
      this.props.history.push('/eg/home');
    }
  }

  handleChange = e => {
    const email = e.target.value;
    this.setState({ email, isEmailError: false, isEmailValid: isEmailFormatValid(email) });
  };

  handleBlur = () => {
    this.setState({ isEmailTouched: true });
  };

  submit = async () => {
    const { email } = this.state;
    this.setState({ loading: true });
    const { t } = this.props;

    try {
      await CmsAPI.forgotPassword(email);
      ToastNotification({
        message: `${t('general.toast.email_send')}`,
        iconName: 'success',
        isMobileView: this.state.isMobileView,
      });
    } catch (e) {
      console.error(e);
      const notFoundError = e.response.data.message === 'resource_not_found';
      ToastNotification({
        message: notFoundError ? t('general.toast.email_send') : t('general.toast.error_during_email_sending'),
        iconName: notFoundError ? 'success' : false,
        isMobileView: this.state.isMobileView,
      });
    }

    this.setState({ loading: false, resetEmailSent: true, isEmailError: false });
  };

  handleSubmit = () => {
    if (this.state.email && !this.state.isEmailError) {
      this.submit();
    }
  };

  render() {
    const { loading, isMobileView, isEmailTouched, isEmailValid, isEmailError, email } = this.state;

    const { t } = this.props;

    return (
      <>
        {!isMobileView && <Nav />}
        <MobileHeader libraryMode={false} />
        <MainContainer className={cx('content-padding play-bg', { [styles.clearBackground]: isMobileView })}>
          {isMobileView && <ProtectedPageSidebar />}
          <div>
            <div>
              <FormContainer title={t('reset_password.title')} className={styles.formHeader}>
                <form className={styles.containerWrapper} onSubmit={this.handleSubmit}>
                  <div className={styles.authCard}>
                    <CustomInput
                      name="email"
                      fieldName={t('general.email')}
                      value={email}
                      onChange={event => this.handleChange(event)}
                      onFocusChanged={this.handleBlur}
                      invalid={isEmailTouched && !isEmailValid}
                      validateMessage={t('my_video.end_video.cta.invalid_email')}
                    />

                    <CustomButton
                      className={cx(styles.submitButton)}
                      variant="primary"
                      onClick={this.submit}
                      loading={loading}
                      loadingText={t('general.password.resetting_password')}
                      disabled={!email || isEmailError || (!isEmailTouched && !isEmailValid) || !isEmailValid}
                      label={t('general.continue')}
                    />
                  </div>
                </form>
              </FormContainer>
            </div>
          </div>
        </MainContainer>
        <Footer />
      </>
    );
  }
}
export default withTranslation()(ForgotPasswordPage);
